export class LoginResponseModel {
    loginOk: boolean;
    mustResetPassword?: boolean;
    member: any;
    errors: string[]
}
